import React, { useState, useEffect, useContext } from 'react';
import { FormControlLabel, Checkbox, TextField, InputAdornment, Avatar, Button, Tooltip } from "@mui/material";
import { FaSearch } from "react-icons/fa";
import VerifiedIcon from '@mui/icons-material/Verified';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { ContactsDetContext } from '../../../ContactsDetContext';
import { ReactComponent as NonVerifiedTickNew } from "../../../../Assets/img/icons/Non-verified-icon.svg";

function AddPeopleToGroup() {
    const { groupDetails, setGroupDetails, groupDetailsEdit, setGroupDetailsEdit } = useContext(ContactsDetContext);
    const navigate = useNavigate();
    const location = useLocation();
    // const { groupName } = location.state || {};
    const [searchParams] = useSearchParams();
    const groupName = searchParams.get('groupName') === 'true';

    // Determine which state to use based on the pathname
    const [currentGroupDetails, setCurrentGroupDetails] = useState(
        location.pathname === '/add_adminGroup' ? groupDetails : groupDetailsEdit
    );
    const [selectAllMembers, setSelectAllMembers] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedItems, setSelectedItems] = useState(
        currentGroupDetails.admins.map(admin => admin.contact_ref_id) || []
    );

    // console.log("Selected members", selectedItems);
    const [selectAll, setSelectAll] = useState(currentGroupDetails?.admins?.length > 0);        // State for "Select All" checkbox
    const [filteredMembers, setFilteredMembers] = useState(currentGroupDetails.members || []);


    const handleSelectAllChange = () => {
        setSelectAll(!selectAll);  // Toggle the selectAll state
    };

    const handleSelectAllMember = () => {
        if (selectAllMembers) {
            // Deselect all members
            setSelectedItems([]);
        } else {
            // Select all members
            const allMemberIds = filteredMembers.map(member => member.contact_ref_id);
            setSelectedItems(allMemberIds);
        }
        // Toggle the state
        setSelectAllMembers(!selectAllMembers);
    };

    const clearAllSelection = () => {
        setSelectedItems([]);
    };

    const handleItemSelection = (id) => {
        setSelectedItems(prevSelectedItems => {
            if (prevSelectedItems.includes(id)) {
                return prevSelectedItems.filter(item => item !== id);
            } else {
                return [...prevSelectedItems, id];
            }
        });
    };

    useEffect(() => {
        // Filter members based on the search term
        setFilteredMembers(
            currentGroupDetails.members.filter(member =>
                member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                member.role.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, currentGroupDetails]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleNextClick = () => {
        // Get selected admins
        const selectedAdmins = currentGroupDetails.members
            .filter(member => selectedItems.includes(member.contact_ref_id))
            .map(member => ({
                contact_ref_id: member.contact_ref_id,
                img: member.img || '', // Use default image if img is null
                name: member.name,
                role: member.role || 'Member',
                email: member.email || `${member.name.toLowerCase().replace(" ", ".")}@example.com`,
                verified: member.verified
            }));


        // Combine existing admins with new selected admins
        const mergedAdmins = [
            ...(currentGroupDetails.admins || []),
            ...selectedAdmins
        ];


        // Remove duplicates based on contact_ref_id
        const uniqueAdmins = Array.from(new Set(mergedAdmins.map(admin => admin.contact_ref_id)))
            .map(id => mergedAdmins.find(admin => admin.contact_ref_id === id));


        const filteredAdmins = uniqueAdmins.filter(admin =>
            selectedAdmins.some(selected => selected.contact_ref_id === admin.contact_ref_id)
        );

        // Update the state
        if (location.pathname === '/add_adminGroup') {
            // If coming from create_group, update groupDetails
            setGroupDetails(prevDetails => ({
                ...prevDetails,
                admins: filteredAdmins
            }));
        } else if (location.pathname === '/addadminEditGroup') {
            // If coming from edit_group, update groupDetailsEdit
            setGroupDetailsEdit(prevDetails => ({
                ...prevDetails,
                admins: filteredAdmins
            }));
        }

        // Navigate to the last page
        if (groupName) {
            navigate('/edit_group', { state: { openDialog: true } });

        } else {
            navigate('/create_group', { state: { openDialog: true } });
        }
    };

    useEffect(() => {
        // Set the current group details based on the pathname whenever it changes
        if (location.pathname === '/add_adminGroup') {
            setCurrentGroupDetails(groupDetails);
        } else if (location.pathname === '/addadminEditGroup') {
            setCurrentGroupDetails(groupDetailsEdit);
        }
    }, [location.pathname, groupDetails, groupDetailsEdit]);


    return (
        <div className="outer-layer-of-contacts">
            <div className="outer-container">
                <div className="displayflex justify-content-between align-items-center">
                    <h6 className="fw-bold">Select Admin</h6>
                    <div className="flex-center">
                        <div className="">
                            {selectAll && <FormControlLabel
                                className='customized_formControl'
                                control={<Checkbox checked={selectAllMembers} onChange={handleSelectAllMember} />}
                                label="Select All"
                            />}
                            <FormControlLabel
                                className='customized_formControl'
                                control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} />}
                                label="Select"
                            />
                        </div>
                        <div style={{ marginRight: '10px' }}>
                            <TextField
                                placeholder="Search..."
                                variant="outlined"
                                size="small"
                                className="me-2"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <div className="icon">
                                                <FaSearch className="icon-color" />
                                            </div>
                                        </InputAdornment>
                                    ),
                                }}
                                style={{ width: '320px' }}
                            />
                        </div>
                    </div>
                </div>

                <div className="avatars-container">
                    {filteredMembers.length > 0 ? (
                        filteredMembers.filter((member) => member?.role !== "ADMIN" && member.contact_ref_id !== groupDetailsEdit?.user_ref_id).map((member, index) => (
                            <div key={index} className={`avatar-box-outer compact`}>
                                <div className={`avatar-box t compact`}>
                                    <div className="flex-center avatar-details-wrapper">

                                        {selectAll ? (
                                            <div className="dot_status_contacts">
                                                <Checkbox
                                                    checked={selectedItems.includes(member.contact_ref_id)}
                                                    onChange={() => handleItemSelection(member.contact_ref_id)}
                                                    className="member-checkbox p-0"
                                                />
                                            </div>
                                        ) : (
                                            <div className="dot_status_contacts"
                                                style={{ backgroundColor: member.verified ? "#43A047" : "#EB4E3D" }}></div>
                                        )}
                                        <div className="avatar-details t">
                                            <div>
                                                <div className="avatar-image t">
                                                    {/* <img className='cover-image' src={member.img} alt={member.name} /> */}
                                                    <Avatar
                                                        className="w-100 h-100 cover-image"
                                                        // sx={{ width: 32, height: 32 }}
                                                        src={member.img} alt={member.name}>
                                                        {member.name.charAt(0).toUpperCase()}
                                                    </Avatar>
                                                </div>
                                                <div className={`symbol_of_contacts compact`}>
                                                    {member.verified ?
                                                        <VerifiedIcon style={{ color: "#43A047" }} /> :
                                                        <NonVerifiedTickNew />
                                                    }
                                                </div>
                                            </div>
                                            <div className="member-info word-break">
                                                <Tooltip title={member.name} placement="bottom">
                                                    <div className="member-name">
                                                        {member.name.length > 10
                                                            ? `${member.name.slice(0, 10)}...`
                                                            : member.name}
                                                    </div>
                                                </Tooltip>
                                                <div className="member-role">{member.role}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div>No members in the group</div>
                    )}
                </div>
            </div>

            {selectedItems.length > 0 && (
                <div className={`action-bar action-barBg2 justify-content-end pe-3 ${Object.keys(selectedItems).length > 0 ? 'open' : ''}`}>
                    <Button className='me-3' variant='contained' onClick={clearAllSelection}
                        sx={{
                            backgroundColor: "#ffff",
                            color: "#0044c6",
                            '&:hover': {
                                backgroundColor: "#ffff", // keep the background white on hover
                                color: "#0044c6", // keep the text color blue on hover
                            }
                        }}>CLEAR ALL</Button>
                    <Button variant='contained' onClick={handleNextClick} sx={{ backgroundColor: "#0044C6" }} >Next</Button>
                </div>
            )}
        </div>
    );
}

export default AddPeopleToGroup;
